import { render } from "./RadioButtonChoice.vue?vue&type=template&id=f22f5650&scoped=true"
import script from "./RadioButtonChoice.vue?vue&type=script&lang=js"
export * from "./RadioButtonChoice.vue?vue&type=script&lang=js"

import "./RadioButtonChoice.vue?vue&type=style&index=0&id=f22f5650&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f22f5650"]])

export default __exports__